import React, { createElement } from 'react';
import moduleCss from './index.module.scss';

export interface Nav_2_props {
    nodeId?: string;
    style: object;
    navList: Array<{
        title: string;
        jumpTo?: string;
        urlTo?: string;
    }>;
    bottom: number;
    right: number;
    width: number;

    backgroundStyle: object;

    titleText: string;
    titleStyle: object;

    textStyle: object;
}

const Nav_2: React.FC<Nav_2_props> = (props) => {
    const {
        nodeId,
        navList,
        bottom,
        right,
        width,
        style,
        backgroundStyle,
        titleText,
        titleStyle,
        textStyle,
    } = props;

    const jump = (event, urlTo) => {
        const { url } = event.currentTarget.dataset;

        if (url) {
            document.getElementById(url).scrollIntoView({ behavior: 'smooth' });

            return false;
        }

        if (urlTo) {
            if (urlTo === 'javascript:scroll(0,0)') {
                document.body.scrollIntoView({ behavior: 'smooth' });
            } else {
                window.open(urlTo, 'target');
            }
        }

        return false;
    };

    return (
        <div
            id={nodeId}
            className={moduleCss.nav_2}
            style={{ right, bottom, width, ...backgroundStyle, ...style }}
        >
            <div className={moduleCss.navTitle} style={titleStyle}>
                {titleText}
            </div>
            <div className={moduleCss.navList}>
                {navList &&
                    navList.map((nav, index) => {
                        return (
                            <div
                                className={moduleCss.navItem}
                                key={index}
                                data-url={nav?.jumpTo}
                                onClick={(event) => {
                                    jump(event, nav?.urlTo);
                                }}
                                style={textStyle}
                            >
                                {nav?.title}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default Nav_2;
